import enMessages from '../json/en_US.json';

const EnLang = {
    messages: {
        ...enMessages,
    },
    locale: 'en-US',
};
export default EnLang;
